export enum APITagType {
  SurveyList = 'survey-list',
  AdminSurvey = 'admin-survey',
  BrandOffer = 'brand-offer',
  Company = 'company',
  InsertionOrder = 'insertion-order',
  InvoiceGroup = 'invoice-group',
  MagazineTitle = 'magazine-title',
  PacingView = 'pacing-view',
  SuspensionReason = 'suspension-reason',
  YodleeBankAccount = 'yodlee-bank-account',
  YodleeToken = 'yodlee-link-token',
  Summaries = 'summaries',
  MediaPlan = 'media-plan',
  PulsePollingConfig = 'pulse-polling-config',
  OrganizationClients = 'organization-clients',
  ClientExclusions = 'client-exclusions',
  Panel = 'panel',
  CommissionInvoices = 'commission-invoices',
  CommissionPnl = 'commission-pnl',
  CommissionReferrals = 'commission-referrals',
  CommissionReports = 'commission-reports',
  CommissionUsers = 'commission-users',
  TrendsEvents = 'trends-events',
  SurveyGroups = 'survey-groups',
  InvoiceLineItemValidation = 'invoice-line-item-validation',
  BillingNeededActions = 'billing-needed-actions',
  BillingDashboard = 'billing-dashboard',
  BillingSku = 'billing-sku',
  SchedulerTasks = 'scheduler-tasks',
  DataJobRuns = 'data-job-runs',
  LogEntries = 'log-entries',
  PortalUsers = 'portal-users',
  PortalUsageLimitConfig = 'portal-usage-limit-config',
  PortalMetrics = 'portal-metrics',
  PortalSubscriptions = 'portal-subscriptions',
  PortalSchedulingConnections = 'portal-scheduling-connections',
  PortalSchedulingRequests = 'portal-scheduling-requests',
  LaunchedCampaigns = 'launched-campaigns',
  ClientCampaignAccess = 'client-campaign-access'
}

export type TagProviderResult = {
  readonly id: string;
  readonly type: APITagType;
};

export type TagInvalidator = APITagType | { id: string, type: APITagType };
